// import { Card } from '@mui/material'
import React from "react";

import PairRow from "./PairRow";

type Props = {
  allPair: any;
  create_gauge: Function;
};

const TableCard: React.FC<Props> = ({ allPair, create_gauge }) => (
  <div className="w-full max-w-full overflow-x-scroll">
    <div className="w-full max-xl:w-[900px]">
      <table className="px-20 bg-white rounded-lg bg-opacity-10 w-full">
        <thead className="bg-white bg-opacity-10 text-white ">
          <tr>
            <th className="py-3">Pair</th>
            <th>Wallet</th>
            <th>My Pool Amount</th>
            {/* <th>My Staked Amount</th> */}
            <th>Total Pool Amount</th>
            <th />
            {/* <th>APY</th> */}
          </tr>
        </thead>
        <tbody className="text-white">
          {allPair.map((item: any) => (
            <PairRow key={item.type} pair={item} create_gauge={create_gauge} />
          ))}
        </tbody>
      </table>
    </div>
  </div>
);

export default TableCard;
